var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.options, function (opt) {
      return _c("a-ext-check-box", {
        attrs: { label: opt.name, width: "120px" },
        on: { change: _vm.onChange },
        model: {
          value: opt.checked,
          callback: function ($$v) {
            _vm.$set(opt, "checked", $$v)
          },
          expression: "opt.checked",
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }